import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: {},
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };
			// ****************** FETCH DOCUMENT ******************
			case types.FETCH_VIDEO_ASSETS_PARAM_LOADING:
				draft.isLoaded = false;
				draft.error = false;
				draft.edit = {};
				return;

			case types.FETCH_VIDEO_ASSETS_PARAM_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_VIDEO_ASSETS_PARAM_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
